function showLoader() {
    setTimeout(function() {
        $('.overlay, body').addClass('loaded');
        setTimeout(function() {
            $('.overlay').css({'display':'none'})
        }, 2000); // Adjust the delay as needed
    }, 2000); // Set the delay to 4 seconds
}
